import React from "react";
import { Check, Moon, ExternalLink } from "lucide-react";
import { DISCORD_LINK } from "@/constants";

const CommunitySection = () => {
  const channels = [
    { name: "general-chat", emoji: "🗣", active: true },
    { name: "success-and-achievements", emoji: "🥳", active: false },
    { name: "shariah-related-resources", emoji: "🌙", active: false },
    { name: "us-stock-news", emoji: "🇺🇸", active: false },
    { name: "psx", emoji: "🇵🇰", active: false },
    { name: "global-markets", emoji: "🌍", active: false },
  ];

  const communityFeatures = [
    "Weekly idea discussions",
    "Member-led research threads",
    "Occasional live sessions or voice chats",
    "Respectful environment grounded in Shariah values",
  ];

  return (
    <section
      id="community"
      data-testid="community-section"
      className="py-20 md:py-32 bg-ics-navy-mid"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="section-divider mx-auto" />
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-ics-white mb-4">
            Community Experience
          </h2>
          <p className="text-ics-gray max-w-2xl mx-auto">
            Join a thriving community of like-minded investors on Discord.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div
            data-testid="discord-mock"
            className="glass-card rounded-2xl overflow-hidden"
          >
            <div className="bg-ics-slate px-4 py-3 flex items-center gap-3 border-b border-white/5">
              <div className="w-8 h-8 rounded-full bg-ics-orange/20 flex items-center justify-center">
                <Moon className="w-4 h-4 text-ics-orange" />
              </div>
              <span className="font-semibold text-ics-white">Investment Circle Shariah</span>
            </div>

            <div className="p-4">
              <div className="text-xs uppercase tracking-wider text-ics-gray mb-3 px-2">
                Text Channels
              </div>
              <div className="space-y-1">
                {channels.map((channel, index) => (
                  <div
                    key={index}
                    data-testid={`discord-channel-${index}`}
                    className={`discord-channel ${channel.active ? 'active' : ''}`}
                  >
                    <span className="text-base">{channel.emoji}</span>
                    <span>{channel.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-white/5 p-4">
              <div className="glass rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-full bg-ics-orange/30 flex items-center justify-center flex-shrink-0">
                    <span className="text-xs font-bold text-ics-orange">M</span>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-sm font-semibold text-ics-white">Member</span>
                      <span className="text-xs text-ics-gray">Today at 2:30 PM</span>
                    </div>
                    <p className="text-sm text-ics-gray">
                      Just posted my analysis on <span className="ticker-tag text-xs">$OGDC</span> in the Pakistan channel. 
                      Looking for feedback on the screening ratios...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="font-heading text-2xl font-semibold text-ics-white">
              What happens in the community?
            </h3>
            <ul className="space-y-4">
              {communityFeatures.map((feature, index) => (
                <li
                  key={index}
                  data-testid={`community-feature-${index}`}
                  className="flex items-start gap-3"
                >
                  <div className="w-6 h-6 rounded-full bg-ics-orange/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-3.5 h-3.5 text-ics-orange" />
                  </div>
                  <span className="text-ics-gray">{feature}</span>
                </li>
              ))}
            </ul>

            <a
              href={DISCORD_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="community-join-discord-btn"
              className="inline-flex items-center gap-2 bg-ics-orange hover:bg-ics-orange-hover text-white font-semibold px-6 py-3 rounded-full transition-all duration-300 hover:scale-105 mt-4"
            >
              Join the Discord
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
